import { useMutation } from '@apollo/client/react'
import { Button, FieldMessage, useTranslate } from '@athena/ui'
import { useState } from 'react'
import {
  CancelStudentConnectionRequestDocument,
  TutorStudentConnectionRequestsDocument,
  type TutorStudentConnectionRequestsQuery,
} from '../../graphql/generated/operations.js'
import { useFirstUserErrorText } from '../../lib/user-errors.js'

export function PendingRequests({
  requests,
}: {
  requests: TutorStudentConnectionRequestsQuery['tutorStudentConnectionRequests']
}) {
  const t = useTranslate()
  const userErrorText = useFirstUserErrorText()
  const [error, setError] = useState<string>()
  const [cancel, { loading }] = useMutation(CancelStudentConnectionRequestDocument, {
    refetchQueries: [TutorStudentConnectionRequestsDocument],
    awaitRefetchQueries: true,
  })
  return (
    <div className="flex flex-col gap-3">
      {requests.length === 0 ? (
        <p className="text-body text-text-secondary">{t('connections.none')}</p>
      ) : null}
      {requests.length > 0 ? (
        <ul className="divide-y divide-border">
          {requests.map((request) => (
            <li
              key={request.id}
              className="flex flex-wrap items-center justify-between gap-3 py-4 first:pt-0 last:pb-0"
            >
              <div className="min-w-0 flex-1">
                <p className="text-body font-semibold break-all">{request.invitedEmail}</p>
                <p className="text-body-sm text-text-secondary">{t('connections.pending')}</p>
              </div>
              <Button
                variant="secondary"
                disabled={loading}
                onClick={() => {
                  setError(undefined)
                  void cancel({ variables: { requestId: request.id } })
                    .then((result) => {
                      const payload = result.data?.cancelStudentConnectionRequest
                      if (!payload?.status)
                        setError(userErrorText(payload?.userErrors, t('connections.failed')))
                    })
                    .catch(() => setError(t('connections.failed')))
                }}
              >
                {t('connections.cancel')}
              </Button>
            </li>
          ))}
        </ul>
      ) : null}
      {requests.length > 0 ? (
        <p className="text-body-sm text-text-secondary">{t('connections.pendingNoSlot')}</p>
      ) : null}
      {error ? <FieldMessage tone="error">{error}</FieldMessage> : null}
    </div>
  )
}
